import { useEffect, useState } from "react";
import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Loader from "./components/Loader";
import Login from "./components/pages/Auth/Login";
import ForgitPassword from "./components/pages/Auth/ForgitPassword";
import Code from "./components/pages/Auth/Code";
import Navbar from "./components/layout/NavBar/NavBar";
import SideBar from "./components/layout/SideBar/SideBar";
import EditProfile from "./components/pages/AdminProfile/EditProfile";
import ChangePassword from "./components/pages/Auth/ChangePassword";
import Home from "./components/pages/HomePage/Home";
import StudentsRigester from "./components/pages/RigesterStudents/StudentsRigester";
import Accounts_Emp from "./components/pages/Accounts_Emp/Accounts_Emp";
import Add_Employee from "./components/pages/Add_Employees/Add_Employees";
import Transfer_Req from "./components/Transfer_Req/Transfer_Req";
import Students from "./components/pages/Students/Students";
import Sorting_Hall_Secretaries from "./components/pages/Sorting_Hall_Secretaries/Sorting_Hall_Secretaries";
import RiotControl from "./components/pages/Riot_Control/Riot_Control";
import Print_Document from "./components/pages/Print_Document/Print_Document";
import Number_Attendees from "./components/pages/Number_Attendees/Number_Attendees";
import No_Register_Course from "./components/pages/No_Register_Course/No_Register_Course";
import News from "./components/pages/News/News";
import Show from "./components/pages/News/Show";
import New_Semester from "./components/pages/New_Semester/New_Semester";
import Create_New_Semester from "./components/pages/New_Semester/Create_New_Semester";
import InfomationApplication from "./components/pages/Infomation_Application/Infomation_Application";
import Import_Question from "./components/pages/Import_Question/Import_Question";
import Graduation_Decision from "./components/pages/Graduation_Decision/Graduation_Decision";
import Graduate_Students from "./components/pages/Graduate_Students/Graduate_Students";
import Freezing_Interfaces from "./components/pages/Freezing_Interfaces/Freezing_Interfaces";
import Freeze_Accounts from "./components/pages/Freeze_Accounts/Freeze_Accounts";
import Fraud_Control from "./components/pages/Fraud_Control/Fraud_Control";
import First_Students from "./components/pages/First_Students/First_Students";
import Examination_Report from "./components/pages/Examination_Report/Examination_Report";
import ExamId from "./components/pages/Examination_Report/ExamId";
import Exam_Penalties_Inquiry from "./components/pages/Exam_Penalties_Inquiry/Exam_Penalties_Inquiry";
import Exam_Lists from "./components/pages/Exam_Lists/Exam_Lists";
import Enter_Results from "./components/pages/Enter_Results/Enter_Results";
import Hall from "./components/pages/Enter_Results/Hall";
import DocumentDelivery from "./components/pages/Document_Delivery/Document_Delivery";
import Distribution_students from "./components/pages/distribution_students/distribution_students";
import Decisions from "./components/pages/Decisions/Decisions";
import Enter_Decisions from "./components/pages/Decisions/Enter_Decisions";
import All_Decisions from "./components/pages/Decisions/All_Decisions";
import DB_Archive from "./components/pages/DB_Archive/DB_Archive";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import Check_Marks_Matching from "./components/pages/Check_Marks_Matching/Check_Marks_Matching";
import ChangedHall from "./components/pages/Change_Hall/Change_Hall";
import Create_Account_Emp from "./components/pages/Accounts_Emp/Create_Account_Emp";
import { RequireAuth } from "./ApiS";
import ActivateInspections from "./components/pages/Activate_Inspections/Activate_Inspections";
import Statistics from "./components/pages/Statistics/Statistics";
import Ads from "./components/Ads/Ads";
import Information_Emp from "./components/pages/Accounts_Emp/Informition_Emp";
import Single_Student from "./components/pages/Students/Single_Student";
import Discount from "./components/pages/New_Semester/Discount";
import Create_New_Discount from "./components/pages/New_Semester/Create_New_Discount";
import Create_news from "./components/pages/News/Create_news";
import Curriculums from "./components/pages/Curce/Curriculums";
import Create_Curce from "./components/pages/Curce/Create_Curce";
import AcadimecFee from "./components/pages/New_Semester/AcadimecFee";
import Create_AcademicFee from "./components/pages/New_Semester/Create_AcademicFee";
import AddProgramRules from "./components/pages/Infomation_Application/ProgramRule/AddProgramRules";
import EditProgramRules from "./components/pages/Infomation_Application/ProgramRule/EditProgramRules";
import About from "./components/pages/Infomation_Application/About/About";
import ProgramRule from "./components/pages/Infomation_Application/ProgramRule/ProgramRule";
import SubjectProgram from "./components/pages/Infomation_Application/SubjectProgram/SubjectProgram";
import TeachingStaff from "./components/pages/Infomation_Application/TeachingStaff/TeachingStaff";
import InfoTeacher from "./components/pages/Infomation_Application/TeachingStaff/InfoTeacher";
import AddInfoTeaches from "./components/pages/Infomation_Application/TeachingStaff/AddInfoTeacher";
import EditInfoTeacher from "./components/pages/Infomation_Application/TeachingStaff/EditInfoTeacher";
// import Statistics from "./components/pages/Statistics/statistics";

function App() {
  const [loading, setLoading] = useState<boolean>(true);
  const { pathname } = useLocation();

  const navigate = useNavigate();

  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="!text-sm ">
        <div className="relative flex">
          {pathname.includes("/login") ||
          pathname.includes("/forget") ||
          pathname.includes("/code") ? (
            ""
          ) : (
            <SideBar />
          )}

          <div className="container mx-auto relative ">
            {pathname.includes("/login") ||
            pathname.includes("/forget") ||
            pathname.includes("/code") ? (
              ""
            ) : (
              <Navbar />
            )}
            <div className="overflow-hidden min-h-[80vh]">
              <>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/forget" element={<ForgitPassword />} />
                  <Route path="/code" element={<Code />} />
                  <Route path="/profile" element={<EditProfile />} />
                  <Route path="/change-password" element={<ChangePassword />} />
                </Routes>
                <RequireAuth>
                  <Routes>
                    
                    <Route path="/" element={<Home />} />
                    {/* <Route path="ٌregesteredemployees">
                    <Route index element={<Accounts_Emp />} />

                    <Route
                      path="/regesteredemployees/:id"
                      element={<Information_Emp />}
                    />
                  </Route> */}
                    {/* <Route
                    path="/regesteredemployees/create_account_emp"
                    element={<Create_Account_Emp />}
                  /> */}
                    <Route
                      path="/regesteredemployees"
                      element={<Accounts_Emp />}
                    />
                    <Route
                      path="/regesteredemployees/:id"
                      element={<Information_Emp />}
                    />
                    <Route
                      path="/regesteredemployees/add"
                      element={<Create_Account_Emp />}
                    />
                    <Route
                      path="/regesteredemployees/:id/edit"
                      element={<Create_Account_Emp />}
                    />

                    <Route path="students">
                      <Route index element={<Students />} />
                      <Route path=":id/edit" element={<Single_Student />} />
                      <Route path="add" element={<Single_Student />} />
                    </Route>

                    <Route
                      path="/ٌregesteredstudents"
                      element={<StudentsRigester />}
                    />
                    <Route path="/transferreq" element={<Transfer_Req />} />
                    <Route path="/statistics" element={<Statistics />} />
                    <Route
                      path="/sorting_hall_secretaries"
                      element={<Sorting_Hall_Secretaries />}
                    />
                    <Route path="/riot_control" element={<RiotControl />} />
                    <Route
                      path="/print_document"
                      element={<Print_Document />}
                    />
                    <Route
                      path="/number_attendees"
                      element={<Number_Attendees />}
                    />
                    <Route
                      path="/no_register_course"
                      element={<No_Register_Course />}
                    />
                    <Route path="/news" element={<News />} />
                    <Route path="/news/createnews" element={<Create_news />} />
                    <Route path="/news/:id/edit" element={<Create_news />} />

                    <Route path="news/show" element={<Show />} />
                    <Route path="/new_semester" element={<New_Semester />} />
                    <Route
                      path="/new_semester/create_new_semester"
                      element={<Create_New_Semester />}
                    />
                    <Route
                      path="/new_semester/:id/edit"
                      element={<Create_New_Semester />}
                    />

                    <Route
                      path="/new_semester/:id/discounts"
                      element={<Create_New_Discount />}
                    />
                    <Route
                      path="/new_semester/:id/discount/:idd/edit"
                      element={<Create_New_Discount />}
                    />
                    <Route
                      path="/new_semester/:id/discount"
                      element={<Discount />}
                    />

                    <Route
                      path="/new_semester/:id/academic-fees"
                      element={<Create_AcademicFee />}
                    />
                    <Route
                      path="/new_semester/:id/academic-fee/:idd/edit"
                      element={<Create_AcademicFee />}
                    />
                    <Route
                      path="/new_semester/:id/academic-fee"
                      element={<AcadimecFee />}
                    />

                    <Route path="/curriculums" element={<Curriculums />} />
                    <Route path="/curriculums/add" element={<Create_Curce />} />
                    <Route
                      path="/curriculums/:id/edit"
                      element={<Create_Curce />}
                    />
                    {/* <Route index element={<InfomationApplication />} /> */}

                    <Route path="/infomation_application">
                      <Route path="about">
                        <Route index element={<About />} />
                      </Route>

                      <Route path="program_role">
                        <Route index element={<ProgramRule />} />
                        <Route path="add" element={<AddProgramRules />} />
                        <Route path=":id/edit" element={<EditProgramRules />} />
                      </Route>

                      <Route path="subject_program">
                        <Route index element={<SubjectProgram />} />
                      </Route>

                      <Route path="teaching_staff">
                        <Route index element={<TeachingStaff />} />
                        <Route path=":id" element={<InfoTeacher />} />
                        <Route path="add" element={<AddInfoTeaches />} />
                        <Route path=":id/edit" element={<EditInfoTeacher />} />
                      </Route>
                    </Route>

                    <Route
                      path="/import_question"
                      element={<Import_Question />}
                    />
                    <Route
                      path="/graduation_decision"
                      element={<Graduation_Decision />}
                    />
                    <Route
                      path="/graduate_students"
                      element={<Graduate_Students />}
                    />
                    <Route
                      path="/freezing_interfaces"
                      element={<Freezing_Interfaces />}
                    />
                    <Route
                      path="/freeze_accounts"
                      element={<Freeze_Accounts />}
                    />
                    <Route path="/fraud_control" element={<Fraud_Control />} />
                    <Route
                      path="/first_students"
                      element={<First_Students />}
                    />
                    <Route
                      path="/examination_report"
                      element={<Examination_Report />}
                    />
                    <Route
                      path="/examination_report/examination"
                      element={<ExamId />}
                    />
                    <Route
                      path="/exam_penalties_inquiry"
                      element={<Exam_Penalties_Inquiry />}
                    />
                    <Route path="/exam_lists" element={<Exam_Lists />} />

                    <Route path="/enter_results" element={<Enter_Results />} />
                    <Route path="/enter_results/hall" element={<Hall />} />
                    <Route
                      path="/document_delivery"
                      element={<DocumentDelivery />}
                    />
                    <Route
                      path="/distribution_students"
                      element={<Distribution_students />}
                    />
                    <Route path="/decisions" element={<Decisions />} />
                    <Route
                      path="/decisions/enter_decisions"
                      element={<Enter_Decisions />}
                    />
                    <Route
                      path="/decisions/all_decisions"
                      element={<All_Decisions />}
                    />
                    <Route path="/db_archive" element={<DB_Archive />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route
                      path="/check_marks_matching"
                      element={<Check_Marks_Matching />}
                    />
                    <Route path="/change_hall" element={<ChangedHall />} />
                    <Route
                      path="/activate_inspections"
                      element={<ActivateInspections />}
                    />
                    <Route path="/ads" element={<Ads />} />
                  </Routes>
                </RequireAuth>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
